import { Markup } from "interweave";
import React, { useContext } from "react";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import Ronaldo from "../../.././../../Assets/Images/ronaldo.jpg";
import "./MarketPlaceSearch.css";

const MarketplaceSearch = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <div>
      <div className="searchUserFirst">
        <h6 className="mx-3 py-2 text-light">MarketPlace</h6>
        <div className="underLineBlackSearch"></div>

        <div className="my-2 py-3">
          <div className="row">
            {props.searchSuggMarketplace?.map((marketplace) => (
              <div className="col-md-6">
                <div className=" row tabBG TabMar">
                  <div className="col-md-6">
                    <div className="">
                      <OwlCarousel
                        items={1}
                        loop
                        autoplay
                        autoplayTimeout={3000}
                        margin={0}
                        dots={false}
                      >
                        <img
                          src={imageCdnUrl + marketplace?.image}
                          alt=""
                          className="img-fluid AuctionsImgSearch "
                        />
                      </OwlCarousel>
                    </div>
                  </div>

                  <div className="col-md-6 containerAuc px-3">
                    <div className="w-100">
                      <h4>{marketplace?.title}</h4>
                      <p className="text-light ">
                        {/* Lorem ipsum dolor sit amet consectetur  */}

                        <Markup
                          content={marketplace?.description.substring(0, 40)}
                        ></Markup>
                      </p>

                      <div className="text-light ">
                        <span className="DollarPrice fw-bold">
                          {" "}
                          $ {marketplace?.unit_price}
                        </span>
                        &nbsp;
                        {/* <small className="text-light "> $ </small> */}
                      </div>
                      <div className="d-flex mt-2 JerseyAucProAuto w-100">
                        <img
                          src={
                            marketplace.superstar?.image
                              ? imageCdnUrl + marketplace.superstar?.image
                              : Ronaldo
                          }
                          className="AuctionProImg img-fluid"
                          alt="star-profile"
                        />
                        <span className="mx-2 mt-1 SpanAu">
                          <small className="proTextSm text-light fw-bold">
                            Superstar
                          </small>
                          <div className="proTextAc">
                            {marketplace.superstar?.first_name}{" "}
                            {marketplace.superstar?.last_name}
                          </div>
                        </span>
                      </div>

                      <Link to={`/marketplace/shipping/${marketplace.slug}`}>
                        <button className="btn bg-warning mt-2  fw-bold w-100 JerseyAucBuy">
                          {" "}
                          Buy Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceSearch;
